import { CropImage } from './CropImage'
import { withCropImage } from './withCropImage'

const ConnectedCropImage = withCropImage(CropImage)

export { ConnectedCropImage as CropImage }
